import "./Impressum.css";
import { Link } from "react-router-dom";
import Footer from "../footer/Footer";
import CookieBanner from "../sharedcomponents/CookieBanner";
import BackButton from "../sharedcomponents/backButton/BackButton";

function Impressum() {
    return (
        <>
            <div className="impressum-container">
                <Link to={"/settings/home/"}><BackButton text="Zurück" /></Link>
                <h2>Impressum</h2>
                <h1>Angaben gemäß § 5 TMG</h1>
                <p>Bitspekt UG (haftungsbeschränkt)<br/>Auguststraße 100<br/>45661 Recklinghausen</p>
                <p>Handelsregister: HRB 9461<br/>Registergericht: Amtsgericht Recklinghausen</p>
                <p><span className="strong-text">Vertreten durch:</span><br/>Mika Andersen (Geschäftsführer)</p>
                <h1>Kontakt</h1>
                <p>Telefon: +49 (0) 2361 8903170<br/>E-Mail: info@bitspekt.de</p>
                <h1>Umsatzsteuer-ID</h1>
                <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br/>DE362308189</p>
                <h1>Redaktionell verantwortlich</h1>
                <p>Mika Andersen<br/>Auguststraße 100<br/>45661 Recklinghausen</p>
                <h1>Verbraucherstreitbeilegung/Universalschlichtungsstelle</h1>
                <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
            </div> 
            <Footer />
            <CookieBanner />
        </>
    )
}

export default Impressum;